module.exports = __webpack_public_path__ + "static/img/playback-max.ec74dc7.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/playback-max.png
// module id = ZQyL
// module chunks = 1